/**
 * Generated from figma plugin `variables2css`
 * Don't forget to add `as const` to color names to have working types
 */
export const rawColors = [
  {
    name: '1. Colors',
    values: [
      {
        mode: {
          name: 'Light',
          id: '5006:4',
        },
        color: [
          {
            name: 'Colors/Base/Blue/1' as const,
            value: '#e6f3ff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/10' as const,
            value: '#003a68',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/2' as const,
            value: '#b9ddff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/3' as const,
            value: '#71bbff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/4' as const,
            value: '#48a7ff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/5' as const,
            value: '#0085ff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/6' as const,
            value: '#007ae1',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/7' as const,
            value: '#0070cd',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/8' as const,
            value: '#0061b1',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Blue/9' as const,
            value: '#005296',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/1' as const,
            value: '#bdf6f6',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/10' as const,
            value: '#054e4e',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/2' as const,
            value: '#8fe5e5',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/3' as const,
            value: '#6ed2d2',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/4' as const,
            value: '#57c4c4',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/5' as const,
            value: '#47b3b3',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/6' as const,
            value: '#34a6a6',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/7' as const,
            value: '#259595',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/8' as const,
            value: '#188181',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Cyan/9' as const,
            value: '#0e6666',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/1' as const,
            value: '#f0f5ff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/10' as const,
            value: '#030852',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/2' as const,
            value: '#d6e4ff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/3' as const,
            value: '#adc6ff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/4' as const,
            value: '#85a5ff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/5' as const,
            value: '#597ef7',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/6' as const,
            value: '#2f54eb',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/7' as const,
            value: '#1d39c4',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/8' as const,
            value: '#10239e',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Geekblue/9' as const,
            value: '#061178',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/1' as const,
            value: '#fffbe6',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/10' as const,
            value: '#613400',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/2' as const,
            value: '#fff1b8',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/3' as const,
            value: '#ffe58f',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/4' as const,
            value: '#ffd666',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/5' as const,
            value: '#ffc53d',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/6' as const,
            value: '#faad14',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/7' as const,
            value: '#d48806',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/8' as const,
            value: '#ad6800',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Gold/9' as const,
            value: '#874d00',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/1' as const,
            value: '#ebf9f2',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/10' as const,
            value: '#115e37',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/2' as const,
            value: '#d6f3e5',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/3' as const,
            value: '#ade7ca',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/4' as const,
            value: '#84dab0',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/5' as const,
            value: '#32c27b',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/6' as const,
            value: '#2ca86a',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/7' as const,
            value: '#269a60',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/8' as const,
            value: '#1f8954',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Green/9' as const,
            value: '#187546',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/1' as const,
            value: '#fcffe6',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/10' as const,
            value: '#254000',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/2' as const,
            value: '#f4ffb8',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/3' as const,
            value: '#eaff8f',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/4' as const,
            value: '#d3f261',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/5' as const,
            value: '#bae637',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/6' as const,
            value: '#a0d911',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/7' as const,
            value: '#7cb305',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/8' as const,
            value: '#5b8c00',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Lime/9' as const,
            value: '#3f6600',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/1' as const,
            value: '#fff0f6',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/10' as const,
            value: '#520339',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/2' as const,
            value: '#ffd6e7',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/3' as const,
            value: '#ffadd2',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/4' as const,
            value: '#ff85c0',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/5' as const,
            value: '#f759ab',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/6' as const,
            value: '#eb2f96',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/7' as const,
            value: '#c41d7f',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/8' as const,
            value: '#9e1068',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Magenta/9' as const,
            value: '#780650',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/1' as const,
            value: '#fef4ed',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/10' as const,
            value: '#a24404',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/2' as const,
            value: '#fee9db',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/3' as const,
            value: '#fdd3b7',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/4' as const,
            value: '#fcbd93',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/5' as const,
            value: '#fa914b',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/6' as const,
            value: '#f08035',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/7' as const,
            value: '#e57225',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/8' as const,
            value: '#d46317',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Orange/9' as const,
            value: '#b9520d',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/1' as const,
            value: '#f5eefc',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/10' as const,
            value: '#480f82',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/2' as const,
            value: '#ebddfa',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/3' as const,
            value: '#d7baf5',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/4' as const,
            value: '#c498ef',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/5' as const,
            value: '#9c53e5',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/6' as const,
            value: '#8e4cd1',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/7' as const,
            value: '#7c34c4',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/8' as const,
            value: '#6821b0',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Purple/9' as const,
            value: '#5a179e',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/1' as const,
            value: '#feecf1',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/10' as const,
            value: '#7d0726',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/2' as const,
            value: '#fdd9e2',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/3' as const,
            value: '#fbb2c6',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/4' as const,
            value: '#f98ca9',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/5' as const,
            value: '#f54070',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/6' as const,
            value: '#e42457',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/7' as const,
            value: '#d01748',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/8' as const,
            value: '#bb0e3c',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Red/9' as const,
            value: '#a50731',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/1' as const,
            value: '#fff2e8',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/10' as const,
            value: '#610b00',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/2' as const,
            value: '#ffd8bf',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/3' as const,
            value: '#ffbb96',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/4' as const,
            value: '#ff9c6e',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/5' as const,
            value: '#ff7a45',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/6' as const,
            value: '#fa541c',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/7' as const,
            value: '#d4380d',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/8' as const,
            value: '#ad2102',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Volcano/9' as const,
            value: '#871400',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/1' as const,
            value: '#feffe6',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/10' as const,
            value: '#614700',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/2' as const,
            value: '#ffffb8',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/3' as const,
            value: '#fffb8f',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/4' as const,
            value: '#fff566',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/5' as const,
            value: '#ffec3d',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/6' as const,
            value: '#fadb14',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/7' as const,
            value: '#d4b106',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/8' as const,
            value: '#ad8b00',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Base/Yellow/9' as const,
            value: '#876800',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Brand/Control/controlItemBgActive' as const,
            value: '#e6f3ff',
            var: 'Colors/Brand/Primary/colorPrimaryBg',
            rootAlias: 'Colors/Base/Blue/1',
          },
          {
            name: 'Colors/Brand/Control/controlItemBgActiveDisabled' as const,
            value: '#9db0df14',
            var: 'Colors/Neutral/Fill/colorFillTertiary',
            rootAlias: 'Colors/Neutral/Fill/colorFillTertiary',
          },
          {
            name: 'Colors/Brand/Control/controlItemBgActiveHover' as const,
            value: '#b9ddff',
            var: 'Colors/Brand/Primary/colorPrimaryBgHover',
            rootAlias: 'Colors/Base/Blue/2',
          },
          {
            name: 'Colors/Brand/Control/controlItemBgHover' as const,
            value: '#9db0df26',
            var: 'Colors/Neutral/Fill/colorFill',
            rootAlias: 'Colors/Neutral/Fill/colorFill',
          },
          {
            name: 'Colors/Brand/Control/controlOutline' as const,
            value: '#0e9af71a',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Brand/Control/controlTmpOutline' as const,
            value: '#9db0df05',
            var: 'Colors/Neutral/Fill/colorFillQuaternary',
            rootAlias: 'Colors/Neutral/Fill/colorFillQuaternary',
          },
          {
            name: 'Colors/Brand/Error/colorError' as const,
            value: '#f54070',
            var: 'Colors/Base/Red/5',
            rootAlias: 'Colors/Base/Red/5',
          },
          {
            name: 'Colors/Brand/Error/colorErrorActive' as const,
            value: '#d01748',
            var: 'Colors/Base/Red/7',
            rootAlias: 'Colors/Base/Red/7',
          },
          {
            name: 'Colors/Brand/Error/colorErrorBg' as const,
            value: '#feecf1',
            var: 'Colors/Base/Red/1',
            rootAlias: 'Colors/Base/Red/1',
          },
          {
            name: 'Colors/Brand/Error/colorErrorBgHover' as const,
            value: '#fdd9e2',
            var: 'Colors/Base/Red/2',
            rootAlias: 'Colors/Base/Red/2',
          },
          {
            name: 'Colors/Brand/Error/colorErrorBorder' as const,
            value: '#fbb2c6',
            var: 'Colors/Base/Red/3',
            rootAlias: 'Colors/Base/Red/3',
          },
          {
            name: 'Colors/Brand/Error/colorErrorBorderHover' as const,
            value: '#f98ca9',
            var: 'Colors/Base/Red/4',
            rootAlias: 'Colors/Base/Red/4',
          },
          {
            name: 'Colors/Brand/Error/colorErrorHover' as const,
            value: '#e42457',
            var: 'Colors/Base/Red/6',
            rootAlias: 'Colors/Base/Red/6',
          },
          {
            name: 'Colors/Brand/Error/colorErrorOutline' as const,
            value: '#f540700f',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Brand/Error/colorErrorText' as const,
            value: '#f54070',
            var: 'Colors/Base/Red/5',
            rootAlias: 'Colors/Base/Red/5',
          },
          {
            name: 'Colors/Brand/Error/colorErrorTextActive' as const,
            value: '#d01748',
            var: 'Colors/Base/Red/7',
            rootAlias: 'Colors/Base/Red/7',
          },
          {
            name: 'Colors/Brand/Error/colorErrorTextHover' as const,
            value: '#e42457',
            var: 'Colors/Base/Red/6',
            rootAlias: 'Colors/Base/Red/6',
          },
          {
            name: 'Colors/Brand/Info/colorInfo' as const,
            value: '#0085ff',
            var: 'Colors/Brand/Primary/colorPrimary',
            rootAlias: 'Colors/Base/Blue/5',
          },
          {
            name: 'Colors/Brand/Info/colorInfoActive' as const,
            value: '#0070cd',
            var: 'Colors/Brand/Primary/colorPrimaryActive',
            rootAlias: 'Colors/Base/Blue/7',
          },
          {
            name: 'Colors/Brand/Info/colorInfoBg' as const,
            value: '#e6f3ff',
            var: 'Colors/Brand/Primary/colorPrimaryBg',
            rootAlias: 'Colors/Base/Blue/1',
          },
          {
            name: 'Colors/Brand/Info/colorInfoBgHover' as const,
            value: '#b9ddff',
            var: 'Colors/Brand/Primary/colorPrimaryBgHover',
            rootAlias: 'Colors/Base/Blue/2',
          },
          {
            name: 'Colors/Brand/Info/colorInfoBorder' as const,
            value: '#71bbff',
            var: 'Colors/Brand/Primary/colorPrimaryBorder',
            rootAlias: 'Colors/Base/Blue/3',
          },
          {
            name: 'Colors/Brand/Info/colorInfoBorderHover' as const,
            value: '#48a7ff',
            var: 'Colors/Brand/Primary/colorPrimaryBorderHover',
            rootAlias: 'Colors/Base/Blue/4',
          },
          {
            name: 'Colors/Brand/Info/colorInfoHover' as const,
            value: '#007ae1',
            var: 'Colors/Brand/Primary/colorPrimaryHover',
            rootAlias: 'Colors/Base/Blue/6',
          },
          {
            name: 'Colors/Brand/Info/colorInfoText' as const,
            value: '#0085ff',
            var: 'Colors/Brand/Primary/colorPrimaryText',
            rootAlias: 'Colors/Base/Blue/5',
          },
          {
            name: 'Colors/Brand/Info/colorInfoTextActive' as const,
            value: '#0070cd',
            var: 'Colors/Brand/Primary/colorPrimaryTextActive',
            rootAlias: 'Colors/Base/Blue/7',
          },
          {
            name: 'Colors/Brand/Info/colorInfoTextHover' as const,
            value: '#007ae1',
            var: 'Colors/Brand/Primary/colorPrimaryTextHover',
            rootAlias: 'Colors/Base/Blue/6',
          },
          {
            name: 'Colors/Brand/Link/colorLink' as const,
            value: '#0085ff',
            var: 'Colors/Brand/Primary/colorPrimary',
            rootAlias: 'Colors/Base/Blue/5',
          },
          {
            name: 'Colors/Brand/Link/colorLinkActive' as const,
            value: '#0070cd',
            var: 'Colors/Brand/Primary/colorPrimaryActive',
            rootAlias: 'Colors/Base/Blue/7',
          },
          {
            name: 'Colors/Brand/Link/colorLinkHover' as const,
            value: '#007ae1',
            var: 'Colors/Brand/Primary/colorPrimaryHover',
            rootAlias: 'Colors/Base/Blue/6',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimary' as const,
            value: '#0085ff',
            var: 'Colors/Base/Blue/5',
            rootAlias: 'Colors/Base/Blue/5',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryActive' as const,
            value: '#0070cd',
            var: 'Colors/Base/Blue/7',
            rootAlias: 'Colors/Base/Blue/7',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryBg' as const,
            value: '#e6f3ff',
            var: 'Colors/Base/Blue/1',
            rootAlias: 'Colors/Base/Blue/1',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryBgHover' as const,
            value: '#b9ddff',
            var: 'Colors/Base/Blue/2',
            rootAlias: 'Colors/Base/Blue/2',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryBorder' as const,
            value: '#71bbff',
            var: 'Colors/Base/Blue/3',
            rootAlias: 'Colors/Base/Blue/3',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryBorderHover' as const,
            value: '#48a7ff',
            var: 'Colors/Base/Blue/4',
            rootAlias: 'Colors/Base/Blue/4',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryHover' as const,
            value: '#007ae1',
            var: 'Colors/Base/Blue/6',
            rootAlias: 'Colors/Base/Blue/6',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryText' as const,
            value: '#0085ff',
            var: 'Colors/Base/Blue/5',
            rootAlias: 'Colors/Base/Blue/5',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryTextActive' as const,
            value: '#0070cd',
            var: 'Colors/Base/Blue/7',
            rootAlias: 'Colors/Base/Blue/7',
          },
          {
            name: 'Colors/Brand/Primary/colorPrimaryTextHover' as const,
            value: '#007ae1',
            var: 'Colors/Base/Blue/6',
            rootAlias: 'Colors/Base/Blue/6',
          },
          {
            name: 'Colors/Brand/Success/colorSuccess' as const,
            value: '#32c27b',
            var: 'Colors/Base/Green/5',
            rootAlias: 'Colors/Base/Green/5',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessActive' as const,
            value: '#269a60',
            var: 'Colors/Base/Green/7',
            rootAlias: 'Colors/Base/Green/7',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessBg' as const,
            value: '#ebf9f2',
            var: 'Colors/Base/Green/1',
            rootAlias: 'Colors/Base/Green/1',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessBgHover' as const,
            value: '#d6f3e5',
            var: 'Colors/Base/Green/2',
            rootAlias: 'Colors/Base/Green/2',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessBorder' as const,
            value: '#ade7ca',
            var: 'Colors/Base/Green/3',
            rootAlias: 'Colors/Base/Green/3',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessBorderHover' as const,
            value: '#84dab0',
            var: 'Colors/Base/Green/4',
            rootAlias: 'Colors/Base/Green/4',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessHover' as const,
            value: '#2ca86a',
            var: 'Colors/Base/Green/6',
            rootAlias: 'Colors/Base/Green/6',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessText' as const,
            value: '#32c27b',
            var: 'Colors/Base/Green/5',
            rootAlias: 'Colors/Base/Green/5',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessTextActive' as const,
            value: '#269a60',
            var: 'Colors/Base/Green/7',
            rootAlias: 'Colors/Base/Green/7',
          },
          {
            name: 'Colors/Brand/Success/colorSuccessTextHover' as const,
            value: '#2ca86a',
            var: 'Colors/Base/Green/6',
            rootAlias: 'Colors/Base/Green/6',
          },
          {
            name: 'Colors/Brand/Warning/colorWarning' as const,
            value: '#fa914b',
            var: 'Colors/Base/Orange/5',
            rootAlias: 'Colors/Base/Orange/5',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningActive' as const,
            value: '#e57225',
            var: 'Colors/Base/Orange/7',
            rootAlias: 'Colors/Base/Orange/7',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningBg' as const,
            value: '#fef4ed',
            var: 'Colors/Base/Orange/1',
            rootAlias: 'Colors/Base/Orange/1',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningBgHover' as const,
            value: '#fee9db',
            var: 'Colors/Base/Orange/2',
            rootAlias: 'Colors/Base/Orange/2',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningBorder' as const,
            value: '#fdd3b7',
            var: 'Colors/Base/Orange/3',
            rootAlias: 'Colors/Base/Orange/3',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningBorderHover' as const,
            value: '#fcbd93',
            var: 'Colors/Base/Orange/4',
            rootAlias: 'Colors/Base/Orange/4',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningHover' as const,
            value: '#f08035',
            var: 'Colors/Base/Orange/6',
            rootAlias: 'Colors/Base/Orange/6',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningOutline' as const,
            value: '#fa914b1a',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningText' as const,
            value: '#fa914b',
            var: 'Colors/Base/Orange/5',
            rootAlias: 'Colors/Base/Orange/5',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningTextActive' as const,
            value: '#e57225',
            var: 'Colors/Base/Orange/7',
            rootAlias: 'Colors/Base/Orange/7',
          },
          {
            name: 'Colors/Brand/Warning/colorWarningTextHover' as const,
            value: '#f08035',
            var: 'Colors/Base/Orange/6',
            rootAlias: 'Colors/Base/Orange/6',
          },
          {
            name: 'Colors/Neutral/colorBgBase' as const,
            value: '#ffffff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/colorTextBase' as const,
            value: '#062d46',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/colorWhite' as const,
            value: '#ffffff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/transparent' as const,
            value: '#00000000',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Bg/colorBgContainer' as const,
            value: '#ffffff',
            var: 'Colors/Neutral/colorBgBase',
            rootAlias: 'Colors/Neutral/colorBgBase',
          },
          {
            name: 'Colors/Neutral/Bg/colorBgContainerDisabled' as const,
            value: '#9db0df14',
            var: 'Colors/Neutral/Fill/colorFillTertiary',
            rootAlias: 'Colors/Neutral/Fill/colorFillTertiary',
          },
          {
            name: 'Colors/Neutral/Bg/colorBgElevated' as const,
            value: '#ffffff',
            var: 'Colors/Neutral/colorBgBase',
            rootAlias: 'Colors/Neutral/colorBgBase',
          },
          {
            name: 'Colors/Neutral/Bg/colorBgLayout' as const,
            value: '#fbfcff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Bg/colorBgMask' as const,
            value: '#062d46b2',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Bg/colorBgSpotlight' as const,
            value: '#062d46',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Bg/colorBgTextActive' as const,
            value: '#9db0df26',
            var: 'Colors/Neutral/Fill/colorFill',
            rootAlias: 'Colors/Neutral/Fill/colorFill',
          },
          {
            name: 'Colors/Neutral/Bg/colorBgTextHover' as const,
            value: '#9db0df1a',
            var: 'Colors/Neutral/Fill/colorFillSecondary',
            rootAlias: 'Colors/Neutral/Fill/colorFillSecondary',
          },
          {
            name: 'Colors/Neutral/Bg/colorBorderBg' as const,
            value: '#ffffff',
            var: 'Colors/Neutral/Bg/colorBgContainer',
            rootAlias: 'Colors/Neutral/colorBgBase',
          },
          {
            name: 'Colors/Neutral/Border/colorBorder' as const,
            value: '#cdddee',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Border/colorBorderSecondary' as const,
            value: '#ecf0fa',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Border/colorSplit' as const,
            value: '#e6ecf9',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Fill/colorFill' as const,
            value: '#9db0df26',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Fill/colorFillAlter' as const,
            value: '#9db0df05',
            var: 'Colors/Neutral/Fill/colorFillQuaternary',
            rootAlias: 'Colors/Neutral/Fill/colorFillQuaternary',
          },
          {
            name: 'Colors/Neutral/Fill/colorFillContent' as const,
            value: '#9db0df1a',
            var: 'Colors/Neutral/Fill/colorFillSecondary',
            rootAlias: 'Colors/Neutral/Fill/colorFillSecondary',
          },
          {
            name: 'Colors/Neutral/Fill/colorFillContentHover' as const,
            value: '#9db0df26',
            var: 'Colors/Neutral/Fill/colorFill',
            rootAlias: 'Colors/Neutral/Fill/colorFill',
          },
          {
            name: 'Colors/Neutral/Fill/colorFillQuaternary' as const,
            value: '#9db0df05',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Fill/colorFillSecondary' as const,
            value: '#9db0df1a',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Fill/colorFillTertiary' as const,
            value: '#9db0df14',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Icon/colorIcon' as const,
            value: '#062d46',
            var: 'Colors/Neutral/Text/colorText',
            rootAlias: 'Colors/Neutral/Text/colorText',
          },
          {
            name: 'Colors/Neutral/Icon/colorIconHover' as const,
            value: '#0085ff',
            var: 'Colors/Base/Blue/5',
            rootAlias: 'Colors/Base/Blue/5',
          },
          {
            name: 'Colors/Neutral/Icon/colorIconSecondary' as const,
            value: '#6f91b7',
            var: 'Colors/Neutral/Text/colorTextSecondary',
            rootAlias: 'Colors/Neutral/Text/colorTextSecondary',
          },
          {
            name: 'Colors/Neutral/Icon/colorIconSecondaryHover' as const,
            value: '#062d46',
            var: 'Colors/Neutral/Text/colorText',
            rootAlias: 'Colors/Neutral/Text/colorText',
          },
          {
            name: 'Colors/Neutral/Icon/colorIconTertiary' as const,
            value: '#547599',
            var: 'Colors/Neutral/Text/colorTextTertiary',
            rootAlias: 'Colors/Neutral/Text/colorTextTertiary',
          },
          {
            name: 'Colors/Neutral/Icon/colorIconTertiaryHover' as const,
            value: '#ffffff',
            var: 'Colors/Neutral/Text/colorTextLightSolid',
            rootAlias: 'Colors/Neutral/Text/colorTextLightSolid',
          },
          {
            name: 'Colors/Neutral/Text/colorText' as const,
            value: '#062d46',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Text/colorTextDescription' as const,
            value: '#6f91b7',
            var: 'Colors/Neutral/Text/colorTextSecondary',
            rootAlias: 'Colors/Neutral/Text/colorTextSecondary',
          },
          {
            name: 'Colors/Neutral/Text/colorTextDisabled' as const,
            value: '#92b4db',
            var: 'Colors/Neutral/Text/colorTextQuaternary',
            rootAlias: 'Colors/Neutral/Text/colorTextQuaternary',
          },
          {
            name: 'Colors/Neutral/Text/colorTextHeading' as const,
            value: '#062d46',
            var: 'Colors/Neutral/Text/colorText',
            rootAlias: 'Colors/Neutral/Text/colorText',
          },
          {
            name: 'Colors/Neutral/Text/colorTextLabel' as const,
            value: '#547599',
            var: 'Colors/Neutral/Text/colorTextTertiary',
            rootAlias: 'Colors/Neutral/Text/colorTextTertiary',
          },
          {
            name: 'Colors/Neutral/Text/colorTextLightSolid' as const,
            value: '#ffffff',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Text/colorTextPlaceholder' as const,
            value: '#92b4db',
            var: 'Colors/Neutral/Text/colorTextQuaternary',
            rootAlias: 'Colors/Neutral/Text/colorTextQuaternary',
          },
          {
            name: 'Colors/Neutral/Text/colorTextQuaternary' as const,
            value: '#92b4db',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Text/colorTextSecondary' as const,
            value: '#6f91b7',
            var: '',
            rootAlias: '',
          },
          {
            name: 'Colors/Neutral/Text/colorTextTertiary' as const,
            value: '#547599',
            var: '',
            rootAlias: '',
          },
        ],
        number: [],
        string: [],
      },
    ],
  },
]
